import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = {
  class: "sub_subject",
  style: {"margin-bottom":"20px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "total-unit_price-section"
}
const _hoisted_7 = { style: {"margin-top":"20px"} }
const _hoisted_8 = {
  key: 0,
  class: "total-unit_price-section"
}
const _hoisted_9 = { style: {"text-align":"right","margin-top":"24px","margin-bottom":"20px"} }

import { ref, onMounted, computed, watch } from "vue";
import {
  NForm,
  NFormItem,
  NGi,
  NFormItemGi,
  NInput,
  NButton,
  NInputNumber,
  NCard,
  NGrid,
  useMessage,
  useNotification,
  FormInst,
  FormRules,
  NRadioGroup,
  NRadio,
  NCheckboxGroup,
  NCheckbox,
  NSpace,
  NDescriptions,
  NDescriptionsItem,
  NDatePicker,
} from "naive-ui";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env";
import { OrgUser, Organization, OrganizationType } from "@/model/organization";
import { Product } from "@/model/product";
import { Order, OrderItem } from "@/model/order";
import { useAlertDialog } from "@/composables/useAlert";
import { useRouter, useRoute } from "vue-router";
import * as constant from "@/constants/constant";

export default /*@__PURE__*/_defineComponent({
  __name: 'OrgOrderReq',
  setup(__props) {

const useAlert = useAlertDialog();
const router = useRouter();
const route = useRoute();

const message = useMessage();
const notification = useNotification();

const pageLoading = ref(false);
const submitLoading = ref(false);
const requestFormRef = ref<FormInst | null>(null);

const prodSet = ref<Product[]>([]);
const surveySet = ref<Product[]>([]);
const coachSet = ref<Product[]>([]);
const activitySet = ref<Product[]>([]);
const expertSet = ref<Product[]>([]);

const selectedCoachSKsForBoth = ref<string[]>([]);
const selectedActivitySKs = ref<string[]>([]);
const selectedExpertSKs = ref<string[]>([]);

const pidFromRoute = ref<string | null>(null);
const orgType = ref<OrganizationType>(OrganizationType.ElementarySchool);
const selectedOrgType = ref<OrganizationType>(
  OrganizationType.ElementarySchool
);

const formModel = ref<
  Order & {
    selectedSurveySK?: string | null;
    test_due_date?: string | null;
    coaching_due_date?: string | null;
  }
>({
  order_id: "",
  SK: "",
  name: "",
  cc: "",
  receiver_email: "",
  client: null,
  payment_method: {
    bank_date: null,
    bank_name: "우리은행 : 1005-104-783814, 예금주:주식회사코코랩",
    deposit_name: "",
    type: "bank_deposit",
  },
  products: [],
  status: "",
  totalPrice: 0,
  type: constant.orderType.BODY,
  selectedSurveySK: null,
  test_due_date: null,
  coaching_due_date: null,
});

const totalPrice = computed(() => {
  return formModel.value.products.reduce((sum, product) => {
    const unit_price = product.unit_price || 0;
    const quantity = product.quantity || 0;
    product.supply_price = Number(unit_price) * quantity;
    return sum + Number(unit_price) * quantity;
  }, 0);
});

const availableProducts = ref<Array<{ label: string; value: string }>>([]);

const baseFormRules: FormRules = {
  "client.dept": [
    {
      required: true,
      message: "담당부서명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.phoneNumber": [
    {
      required: true,
      message: "전화번호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.deptPersonName": [
    {
      required: true,
      message: "담당자 성명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.deptPersonPhoneNumber": [
    {
      required: true,
      message: "핸드폰번호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.email": [
    {
      required: true,
      message: "이메일을 입력해주세요.",
      trigger: ["input", "blur"],
    },
    {
      type: "email",
      message: "올바른 이메일 형식이 아닙니다.",
      trigger: ["input", "blur"],
    },
  ],
  "payment_method.bank_date": [
    {
      required: true,
      message: "입금예정일을 선택해주세요.",
      trigger: "change",
    },
  ],
  quantityRule: [
    {
      required: true,
      type: "number",
      message: "수량을 입력해주세요.",
      trigger: ["input", "blur"],
      min: 1,
    },
  ],
};

const surveyFormRules: FormRules = {
  ...baseFormRules,
  test_due_date: [
    {
      required: true,
      message: "검사실시 예정일을 선택해주세요.",
      trigger: "change",
    },
  ],
  // coaching_due_date: [
  //   {
  //     required: true,
  //     message: "상담코칭 예정일을 선택해주세요.",
  //     trigger: "change",
  //   },
  // ],
  selectedSurveySK: [
    { required: true, message: "검사 유형을 선택해주세요.", trigger: "change" },
  ],
};

const expertFormRules: FormRules = {
  ...baseFormRules,
};

const formRules: FormRules =
  (route.params.pid as string) == constant.OrderType.EXPERT
    ? expertFormRules
    : surveyFormRules;

const requestOrgQuotationCallable = getCallable("requestOrgQuotation");

function isUniversity(item: OrderItem): boolean {
  if (
    item.type == "putt_u" ||
    item.type == "tec" ||
    item.type == "coach_putt_u" ||
    item.type == "coach_tec" ||
    item.type == "coach_putt_tec"
  ) {
    return true;
  } else {
    return false;
  }
}

async function setSurveyProdItems() {
  surveySet.value = [];
  coachSet.value = [];
  const surveyBoth = {
    SK: "B",
    name: "",
  };
  const fullProdSet = await common.getProductSetList();
  if (selectedOrgType.value === OrganizationType.ElementarySchool) {
    prodSet.value = fullProdSet[0];
    surveyBoth.name = "PUTT2.0_초등학생용‧TOCC_아동용(고학년)";
  } else if (selectedOrgType.value === OrganizationType.MiddleSchool) {
    prodSet.value = fullProdSet[1];
    surveyBoth.name = "PUTT2.0_중학생용‧TOCC_청소년용";
  } else if (selectedOrgType.value === OrganizationType.HighSchool) {
    prodSet.value = fullProdSet[2];
    surveyBoth.name = "PUTT2.0_고등학생용‧TOCC_청소년용";
  } else if (selectedOrgType.value === OrganizationType.University) {
    prodSet.value = fullProdSet[3];
    surveyBoth.name = "PUTT2.0_대학생용‧TEC_전문가용";
  }
  for (const product of prodSet.value) {
    if (product.SK?.startsWith("personal")) {
      surveySet.value.push(product);
    } else {
      coachSet.value.push(product);
    }
  }
  surveySet.value.push(surveyBoth);
}

async function setActivityProdItems() {
  activitySet.value = [];
  const fullProdSet = common.getActivityProductSetList();
  if (selectedOrgType.value === OrganizationType.ElementarySchool) {
    prodSet.value = fullProdSet[0];
  } else if (selectedOrgType.value === OrganizationType.MiddleSchool) {
    prodSet.value = fullProdSet[1];
  } else if (selectedOrgType.value === OrganizationType.HighSchool) {
    prodSet.value = fullProdSet[2];
  } else if (selectedOrgType.value === OrganizationType.University) {
    prodSet.value = fullProdSet[3];
  }
  for (const product of prodSet.value) {
    activitySet.value.push(product);
  }
}

async function setExportProdItems() {
  if (expertSet.value && expertSet.value.length > 0) return;
  expertSet.value = [];
  const fullProdSet = common.getExpertProductSetList();
  for (const product of fullProdSet) {
    expertSet.value.push(product);
  }
}

async function setProdItems() {
  if (pidFromRoute.value == constant.OrderType.ACTIVITY) {
    await setActivityProdItems();
  } else if (pidFromRoute.value == constant.OrderType.EXPERT) {
    await setExportProdItems();
  } else if (pidFromRoute.value == constant.OrderType.SURVEY) {
    await setSurveyProdItems();
  } else {
    router.push({ name: USER_ROUTES.Price.Org.Name });
  }
}

onMounted(async () => {
  pidFromRoute.value = route.params.pid as string;
  pageLoading.value = true;
  try {
    const localAuthData = common.getLocalAuth();
    if (localAuthData) {
      if (localAuthData.org && typeof localAuthData.org === "object") {
        formModel.value.client = {
          uid: localAuthData.orgId,
          ...localAuthData.org,
        };
        formModel.value.payment_method.deposit_name = localAuthData.org.name;
        orgType.value = localAuthData.org.type;
        let determinedOrgType =
          orgType.value === OrganizationType.Etc
            ? OrganizationType.ElementarySchool
            : orgType.value;
        await setProdItems();
        if (selectedOrgType.value !== determinedOrgType) {
          selectedOrgType.value = determinedOrgType;
        } else {
          await setProdItems();
        }
      } else {
        pageLoading.value = false;
        await useAlert("기관 회원전용 페이지 입니다.");
        router.push({ name: USER_ROUTES.Home.Name });
      }
    } else {
      pageLoading.value = false;
      await useAlert("회원전용 페이지 입니다.");
      router.push({ name: USER_ROUTES.Home.Name });
    }
  } catch (err) {
    console.log(err);
  } finally {
    pageLoading.value = false;
  }
});

const updateRequestedProducts = () => {
  const oldProducts: Map<string, OrderItem> = new Map(
    formModel.value.products.map((p) => [p.prod_id, p])
  );
  const newProducts: OrderItem[] = [];

  if (!formModel.value.selectedSurveySK) {
    formModel.value.products = [];
    return;
  }

  const selectedSurveyProduct = surveySet.value.find(
    (s) => s.SK === formModel.value.selectedSurveySK
  );
  if (selectedSurveyProduct) {
    coachSet.value = [];
    if (selectedSurveyProduct.type?.startsWith("putt")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_putt") &&
          !product.type?.startsWith("coach_putt_tocc") &&
          !product.type?.startsWith("coach_putt_tec")
        ) {
          coachSet.value.push(product);
        }
      }
    } else if (selectedSurveyProduct.type?.startsWith("tocc")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_tocc")
        ) {
          coachSet.value.push(product);
        }
      }
    } else if (selectedSurveyProduct.type?.startsWith("tec")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_tec")
        ) {
          coachSet.value.push(product);
        }
      }
    } else {
      for (const product of prodSet.value) {
        if (!product.SK?.startsWith("personal")) {
          coachSet.value.push(product);
        }
      }
    }

    if (formModel.value.selectedSurveySK === "B") {
      for (const surveyProduct of surveySet.value) {
        if (surveyProduct.SK === "B") continue;
        newProducts.push({
          prod_id: surveyProduct.SK!,
          name: surveyProduct.name,
          price: surveyProduct.price,
          type: surveyProduct.type,
          unit_price: surveyProduct.price,
          template_form_id: surveyProduct.template_form_id, // Ensure this property exists on surveyProduct or handle if optional
          quantity: oldProducts.get(surveyProduct.SK!)?.quantity || 1,
          supply_price: surveyProduct.price * 1,
          notes: "",
          grade: oldProducts.get(surveyProduct.SK!)?.grade || null,
          major: oldProducts.get(surveyProduct.SK!)?.major || null,
          class_num: oldProducts.get(surveyProduct.SK!)?.class_num || null,
        });
      }
    } else {
      newProducts.push({
        prod_id: selectedSurveyProduct.SK!,
        name: selectedSurveyProduct.name,
        price: selectedSurveyProduct.price,
        type: selectedSurveyProduct.type,
        unit_price: selectedSurveyProduct.price,
        template_form_id: selectedSurveyProduct.template_form_id, // Ensure this property exists or handle if optional
        quantity: oldProducts.get(selectedSurveyProduct.SK!)?.quantity || 1,
        supply_price: selectedSurveyProduct.price * 1,
        notes: "",
        grade: oldProducts.get(selectedSurveyProduct.SK!)?.grade || null,
        major: oldProducts.get(selectedSurveyProduct.SK!)?.major || null,
        class_num:
          oldProducts.get(selectedSurveyProduct.SK!)?.class_num || null,
      });
    }
  }

  // if (formModel.value.selectedSurveySK === "B") {
  selectedCoachSKsForBoth.value.forEach((coachSK) => {
    const coachProduct = coachSet.value.find((c) => c.SK === coachSK);
    if (coachProduct) {
      newProducts.push({
        prod_id: coachProduct.SK!,
        price: coachProduct.price,
        unit_price: coachProduct.price,
        name: coachProduct.name,
        quantity: oldProducts.get(coachProduct.SK!)?.quantity || 1,
        supply_price: coachProduct.price * 1,
        notes: "",
        grade: oldProducts.get(coachProduct.SK!)?.grade || null,
        major: oldProducts.get(coachProduct.SK!)?.major || null,
        class_num: oldProducts.get(coachProduct.SK!)?.class_num || null,
      });
    }
  });
  // } else {
  // const originalSurveys = surveySet.value.filter((s) => s.SK !== "B");
  // const originalCoaches = coachSet.value.filter((c) => c.SK !== "B");
  // const surveyIndex = originalSurveys.findIndex(
  //   (s) => s.SK === formModel.value.selectedSurveySK
  // );
  // if (surveyIndex !== -1 && surveyIndex < originalCoaches.length) {
  //   const correspondingCoach = originalCoaches[surveyIndex];
  //   if (correspondingCoach) {
  //     if (!newProducts.find((p) => p.prod_id === correspondingCoach.SK)) {
  //       newProducts.push({
  //         prod_id: correspondingCoach.SK!,
  //         name: correspondingCoach.name,
  //         price: correspondingCoach.price,
  //         unit_price: correspondingCoach.price,
  //         quantity: oldProducts.get(correspondingCoach.SK!)?.quantity || 1,
  //         supply_price: correspondingCoach.price * 1,
  //         notes: "",
  //         grade: oldProducts.get(correspondingCoach.SK!)?.grade || null,
  //         major: oldProducts.get(correspondingCoach.SK!)?.major || null,
  //         class_num:
  //           oldProducts.get(correspondingCoach.SK!)?.class_num || null,
  //       });
  //     }
  //   }
  // }
  // }
  formModel.value.products = newProducts;
};

const updateActivityRequestedProducts = async () => {
  const oldQuantities = new Map(
    formModel.value.products.map((p) => [p.prod_id, p.quantity])
  );
  const newProducts: OrderItem[] = [];
  for (const acitivySK of selectedActivitySKs.value) {
    const activityProduct = activitySet.value.find((c) => c.SK === acitivySK);
    if (activityProduct) {
      let prd = {
        prod_id: activityProduct.SK!,
        price: activityProduct.price,
        unit_price: activityProduct.price,
        name: activityProduct.name,
        type: activityProduct.type,
        quantity: oldQuantities.get(activityProduct.SK!) || 1,
        supply_price: activityProduct.price * 1,
        template_form_id: "",
        notes: "",
      };
      if (activityProduct.type?.startsWith("putt_")) {
        const findPutt: Product | undefined = await common.getProduct(
          activityProduct.type
        );
        if (findPutt) {
          prd.template_form_id = findPutt.template_form_id;
        }
      }
      newProducts.push(prd);
    }
  }
  formModel.value.products = newProducts;
};

const updateExpertRequestedProducts = async () => {
  const oldQuantities = new Map(
    formModel.value.products.map((p) => [p.prod_id, p.quantity])
  );
  const newProducts: OrderItem[] = [];
  for (const expertSK of selectedExpertSKs.value) {
    const expertProduct = expertSet.value.find((c) => c.SK === expertSK);
    if (expertProduct) {
      newProducts.push({
        prod_id: expertProduct.SK!,
        price: expertProduct.price,
        unit_price: expertProduct.price,
        name: expertProduct.name,
        type: expertProduct.type,
        quantity: oldQuantities.get(expertProduct.SK!) || 1,
        supply_price: expertProduct.price * 1,
        notes: "",
      });
    }
  }
  formModel.value.products = newProducts;
};

watch(
  () => formModel.value.selectedSurveySK,
  (newVal) => {
    // if (newVal !== "B" && newVal !== undefined) {
    //   // Check newVal is not undefined if it can be
    //   selectedCoachSKsForBoth.value = []; // Reset checkboxes if not "Both" survey
    // }
    updateRequestedProducts();
  }
);

watch(
  selectedCoachSKsForBoth,
  () => {
    // if (formModel.value.selectedSurveySK === "B") {
    updateRequestedProducts();
    // }
  },
  { deep: true }
);

watch(selectedActivitySKs, async () => {
  await updateActivityRequestedProducts();
});

watch(selectedExpertSKs, () => {
  updateExpertRequestedProducts();
});
watch(selectedOrgType, async (newType, oldType) => {
  if (newType && newType !== oldType) {
    pageLoading.value = true;
    await setProdItems();
    // 기관 유형이 변경되면 선택된 검사 및 코칭 상품 초기화
    formModel.value.selectedSurveySK = null;
    selectedCoachSKsForBoth.value = [];
    formModel.value.products = []; // 요청 상품 목록도 초기화
    pageLoading.value = false;
  }
});
async function handleSubmitRequest() {
  try {
    await requestFormRef.value?.validate();
    if (formModel.value.products.length === 0) {
      message.error("요청할 상품을 하나 이상 선택해주세요.");
      return;
    }
  } catch (errors) {
    await useAlert("입력 내용을 확인해주세요.");
    return;
  }

  submitLoading.value = true;
  try {
    const payload = {
      ...formModel.value,
      totalPrice: totalPrice.value,
    };
    const result = await requestOrgQuotationCallable(payload);
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "요청 성공",
        description:
          "견적 요청이 성공적으로 전송되었습니다. 담당자가 확인 후 연락드리겠습니다.",
        duration: 3000,
      });
      router.push({ name: USER_ROUTES.Mypage.Order.Org.RequestList.Name });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "견적 요청 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("견적 요청 실패:", error);
    notification.error({
      title: "오류 발생",
      description: `견적 요청 중 오류가 발생했습니다: ${
        error.message || "알 수 없는 오류"
      }`,
      duration: 3000,
    });
  } finally {
    submitLoading.value = false;
  }
}

function handleCancel() {
  router.back(); // Go back to the previous page (Table.vue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (pageLoading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(pidFromRoute.value == constant.OrderType.SURVEY
              ? "[기관] 검사 및 상담코칭 신청서 작성"
              : pidFromRoute.value == constant.OrderType.ACTIVITY
              ? "[기관] Activity 신청서 작성"
              : pidFromRoute.value == constant.OrderType.EXPERT
              ? "[기관] 전문가 교육 신청서 작성"
              : "기관 신청서 작성"), 1),
        _createVNode(_unref(NForm), {
          ref_key: "requestFormRef",
          ref: requestFormRef,
          model: formModel.value,
          rules: _unref(formRules),
          "label-placement": "left",
          "require-mark-placement": "right-hanging"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCard), {
              title: "기관 정보",
              style: {"margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                (formModel.value.client)
                  ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                      key: 0,
                      "label-placement": "left",
                      column: 2,
                      size: "small",
                      bordered: "",
                      class: "org-info-descriptions",
                      style: {"margin-bottom":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관명",
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formModel.value.client.name || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "대표자 이름" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formModel.value.client.president || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "기관 유형" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getOrganizationTypeString(
                  formModel.value.client.type as OrganizationType
                )), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "기관 주소",
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(formModel.value.client.address.address || "") + " " + _toDisplayString(formModel.value.client.address.addressDetail || ""), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당부서명" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "client.dept",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.client.dept,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.client.dept) = $event)),
                                  placeholder: "담당부서"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "전화번호" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "client.phoneNumber",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.client.phoneNumber,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.client.phoneNumber) = $event)),
                                  placeholder: "010-1234-5678"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자 성명" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "client.deptPersonName",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.client.deptPersonName,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.client.deptPersonName) = $event)),
                                  placeholder: "담당자명"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "핸드폰번호" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "client.deptPersonPhoneNumber",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.client.deptPersonPhoneNumber,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.client.deptPersonPhoneNumber) = $event)),
                                  placeholder: "010-1234-5678"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "이메일",
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "client.email",
                              "show-label": false,
                              style: {"margin-bottom":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: formModel.value.client.email,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.client.email) = $event)),
                                  placeholder: "contact@example.com"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (
              pidFromRoute.value == constant.OrderType.SURVEY ||
              pidFromRoute.value == constant.OrderType.ACTIVITY
            )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (orgType.value == _unref(OrganizationType).Etc)
                    ? (_openBlock(), _createBlock(_unref(NCard), {
                        key: 0,
                        title: "검사 대상 선택",
                        style: {"margin-top":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NRadioGroup), {
                            value: selectedOrgType.value,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((selectedOrgType).value = $event)),
                            name: "orgTypeSelection"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSpace), null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_unref(NRadio), {
                                    key: _unref(OrganizationType).ElementarySchool,
                                    value: _unref(OrganizationType).ElementarySchool,
                                    label: "초등학교"
                                  }, null, 8, ["value"])),
                                  (_openBlock(), _createBlock(_unref(NRadio), {
                                    key: _unref(OrganizationType).MiddleSchool,
                                    value: _unref(OrganizationType).MiddleSchool,
                                    label: "증학교"
                                  }, null, 8, ["value"])),
                                  (_openBlock(), _createBlock(_unref(NRadio), {
                                    key: _unref(OrganizationType).HighSchool,
                                    value: _unref(OrganizationType).HighSchool,
                                    label: "고등학교"
                                  }, null, 8, ["value"])),
                                  (_openBlock(), _createBlock(_unref(NRadio), {
                                    key: _unref(OrganizationType).University,
                                    value: _unref(OrganizationType).University,
                                    label: "대학교"
                                  }, null, 8, ["value"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (pidFromRoute.value == constant.OrderType.SURVEY)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_unref(NCard), {
                          title: "검사 종류 선택",
                          style: {"margin-top":"20px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItem), {
                              path: "selectedSurveySK",
                              "label-placement": "left"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NRadioGroup), {
                                  value: formModel.value.selectedSurveySK,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formModel.value.selectedSurveySK) = $event)),
                                  name: "surveySelection"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NSpace), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveySet.value, (survey) => {
                                          return (_openBlock(), _createBlock(_unref(NRadio), {
                                            key: survey.SK,
                                            value: survey.SK!,
                                            label: survey.name
                                          }, null, 8, ["value", "label"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (formModel.value.selectedSurveySK)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_unref(NCard), {
                                title: "코칭 상품 선택 (다중 선택 가능)",
                                style: {"margin-top":"20px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NCheckboxGroup), {
                                    value: selectedCoachSKsForBoth.value,
                                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((selectedCoachSKsForBoth).value = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSpace), { "item-style": "display: flex;" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachSet.value, (coach) => {
                                            return (_openBlock(), _createBlock(_unref(NCheckbox), {
                                              key: coach.SK,
                                              value: coach.SK!,
                                              label: coach.name
                                            }, null, 8, ["value", "label"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(_unref(NCard), {
                        key: 2,
                        title: "상품 선택 (다중 선택 가능)",
                        style: {"margin-top":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NCheckboxGroup), {
                            value: selectedActivitySKs.value,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((selectedActivitySKs).value = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSpace), {
                                vertical: "",
                                "item-style": "display: flex;"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activitySet.value, (acitivy) => {
                                    return (_openBlock(), _createBlock(_unref(NCheckbox), {
                                      key: acitivy.SK,
                                      value: acitivy.SK!,
                                      label: acitivy.name
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })),
                  _createVNode(_unref(NCard), {
                    title: "신청 상품 및 수량",
                    style: {"margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formModel.value.products, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.prod_id,
                          class: "product-request-item"
                        }, [
                          _createVNode(_unref(NDescriptions), {
                            title: item.name,
                            "label-placement": "left",
                            column: 3,
                            size: "small",
                            bordered: ""
                          }, {
                            default: _withCtx(() => [
                              (isUniversity(item))
                                ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                    key: 0,
                                    label: "학과",
                                    "label-placement": "left",
                                    style: {"text-align":"right"},
                                    labelStyle: "width:100px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NInput), {
                                        value: item.major,
                                        "onUpdate:value": ($event: any) => ((item.major) = $event),
                                        placeholder: "학과"
                                      }, null, 8, ["value", "onUpdate:value"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "학년",
                                "label-placement": "left",
                                style: {"text-align":"right"},
                                labelStyle: "width:100px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInput), {
                                    value: item.grade,
                                    "onUpdate:value": ($event: any) => ((item.grade) = $event),
                                    placeholder: "학년"
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1024),
                              (!isUniversity(item))
                                ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                                    key: 1,
                                    label: "학급수",
                                    "label-placement": "left",
                                    labelStyle: "width:100px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NInput), {
                                        value: item.class_num,
                                        "onUpdate:value": ($event: any) => ((item.class_num) = $event),
                                        placeholder: "학급수"
                                      }, null, 8, ["value", "onUpdate:value"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "",
                                "label-placement": "left",
                                labelStyle: "width:100px"
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("   ")
                                ])),
                                _: 1
                              }),
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "단가(원)",
                                contentStyle: "text-align: right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(common.formatNumberWithCommas(Number(item.unit_price))), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(NDescriptionsItem), {
                                path: `products[${index}].quantity`,
                                rule: _unref(formRules).quantityRule,
                                label: "총인원수"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputNumber), {
                                    value: item.quantity,
                                    "onUpdate:value": ($event: any) => ((item.quantity) = $event),
                                    placeholder: "수량",
                                    min: 1
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1032, ["path", "rule"]),
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "금액(원)",
                                contentStyle: "text-align: right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(common.formatNumberWithCommas(
                        Number(item.unit_price) * item.quantity
                      )), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]))
                      }), 128)),
                      (formModel.value.products.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(NGrid), {
                              cols: 12,
                              "x-gap": 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NGi), { span: 7 }),
                                _createVNode(_unref(NGi), {
                                  span: 5,
                                  style: {"text-align":"right","font-weight":"bold","font-size":"1.1em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 총 결제 금액: " + _toDisplayString(common.formatNumberWithCommas(totalPrice.value)) + "원 ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(NGrid), {
                          cols: 12,
                          "x-gap": 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NGi), { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NFormItem), {
                                  label: "검사 실시 예정일",
                                  path: "test_due_date"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(NDatePicker), {
                                      "formatted-value": formModel.value.test_due_date,
                                      "onUpdate:formattedValue": _cache[9] || (_cache[9] = ($event: any) => ((formModel.value.test_due_date) = $event)),
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      placeholder: "검사 실시 예정일 선택",
                                      style: {"width":"200px"}
                                    }, null, 8, ["formatted-value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NGi), {
                              span: 12,
                              style: {"padding-top":"5px"}
                            }, {
                              default: _withCtx(() => [
                                (selectedCoachSKsForBoth.value.length > 0)
                                  ? (_openBlock(), _createBlock(_unref(NFormItem), {
                                      key: 0,
                                      label: "상담 코칭 예정일",
                                      path: "coaching_due_date"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NDatePicker), {
                                          "formatted-value": formModel.value.coaching_due_date,
                                          "onUpdate:formattedValue": _cache[10] || (_cache[10] = ($event: any) => ((formModel.value.coaching_due_date) = $event)),
                                          "value-format": "yyyy-MM-dd",
                                          type: "date",
                                          placeholder: "상담 코칭 예정일 선택",
                                          style: {"width":"200px"}
                                        }, null, 8, ["formatted-value"]),
                                        _cache[14] || (_cache[14] = _createElementVNode("span", { style: {"margin-left":"10px","color":"red"} }, "(일정은 검사 완료 및 결과리포트를 수령, 확인 후이어야 함. 042-867-5558)", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_unref(NCard), {
                    title: "상품 선택 (다중 선택 가능)",
                    style: {"margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NCheckboxGroup), {
                        value: selectedExpertSKs.value,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((selectedExpertSKs).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), {
                            vertical: "",
                            "item-style": "display: flex;"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expertSet.value, (expert) => {
                                return (_openBlock(), _createBlock(_unref(NCheckbox), {
                                  key: expert.SK,
                                  value: expert.SK!,
                                  label: expert.name
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NCard), {
                    title: "신청 상품 및 수량",
                    style: {"margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formModel.value.products, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.prod_id,
                          class: "product-request-item"
                        }, [
                          _createVNode(_unref(NDescriptions), {
                            title: item.name,
                            "label-placement": "left",
                            column: 3,
                            size: "small",
                            bordered: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "단가(원)",
                                contentStyle: "text-align: right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(common.formatNumberWithCommas(Number(item.unit_price))), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(NDescriptionsItem), {
                                path: `products[${index}].quantity`,
                                rule: _unref(formRules).quantityRule,
                                label: "총인원수"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputNumber), {
                                    value: item.quantity,
                                    "onUpdate:value": ($event: any) => ((item.quantity) = $event),
                                    placeholder: "수량",
                                    min: 1
                                  }, null, 8, ["value", "onUpdate:value"])
                                ]),
                                _: 2
                              }, 1032, ["path", "rule"]),
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "금액(원)",
                                contentStyle: "text-align: right"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(common.formatNumberWithCommas(
                        Number(item.unit_price) * item.quantity
                      )), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["title"])
                        ]))
                      }), 128)),
                      (formModel.value.products.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_unref(NGrid), {
                              cols: 12,
                              "x-gap": 12
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NGi), { span: 7 }),
                                _createVNode(_unref(NGi), {
                                  span: 5,
                                  style: {"text-align":"right","font-weight":"bold","font-size":"1.1em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 총 결제 금액: " + _toDisplayString(common.formatNumberWithCommas(totalPrice.value)) + "원 ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ], 64)),
            _createVNode(_unref(NCard), {
              title: "결제 정보",
              style: {"margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NDescriptions), {
                  "label-placement": "left",
                  column: 2,
                  size: "small",
                  bordered: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NDescriptionsItem), {
                      label: "결제계좌",
                      "label-placement": "left",
                      style: {"text-align":"right"},
                      labelStyle: "width:100px;",
                      contentStyle: "text-align: center; ;align-content: center;"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formModel.value.payment_method.bank_name || "N/A"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NDescriptionsItem), {
                      label: "입금예정일",
                      "label-placement": "left",
                      labelStyle: "width:100px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NFormItem), {
                          path: "payment_method.bank_date",
                          "show-label": false,
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NDatePicker), {
                              "formatted-value": formModel.value.payment_method.bank_date,
                              "onUpdate:formattedValue": _cache[12] || (_cache[12] = ($event: any) => ((formModel.value.payment_method.bank_date) = $event)),
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              placeholder: "입금 예정일 선택",
                              style: {"width":"100%"}
                            }, null, 8, ["formatted-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(NButton), {
                onClick: handleCancel,
                style: {"margin-right":"12px"}
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("취소")
                ])),
                _: 1
              }),
              _createVNode(_unref(NButton), {
                type: "primary",
                onClick: handleSubmitRequest,
                loading: submitLoading.value
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("기관 신청서 제출")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}
}

})